// tslint:disable:object-literal-sort-keys
export const breakpoints = {
    desktop: 1200,
    mobile: 768,
    small: 320,
    smallest: 0,
}
